import documentMasterDataReducer from "./reducers";

export default documentMasterDataReducer;